<div [ngStyle]="{ backgroundColor: tabsSelectorBgColor, marginTop, marginBottom }" class="tabs">
  <div [ngStyle]="{ borderRadius: activeTabBorderRadius }" class="tab-slider-bg"></div>
  @for (tab of filteredTabs; track tab; let i = $index) {
    <button (click)="selectTab(i)" [class.active]="activeTab === i" [class.disabled]="disabled" [disabled]="disabled" [routerLink]="tab.routerLink ?? null" class="tab">
      {{ tab.displayName || tab.label }}
      @if (tab?.info) {
        <app-icon iconName="question-circle" marginLeft="5px" [tippy]="tab?.info"></app-icon>
      }
    </button>
  }
</div>
